import { Card, Collapse, Stack, Typography } from "@mui/material";
import React from "react";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Box from "@mui/material/Box";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormCustomizableTextTC from "../../../components/Forms/FormCustomizableTextTC";
import { VestigingFormContext } from "../VestigingForm";
import { AsyncProductAutocomplete } from "../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { apiProviderSupportsFeature, apiProviderSupportsFeatureList } from "../../../variables/app";

export default function Beveiliging() {
  const useRandomPincode = useWatch({ name: "custom_data.qrv5.random_pincodes.enabled" });
  const { vestigingId, menukaartVestigingId }: VestigingFormContext = useFormContext<VestigingFormContext>();
  const {
    field: { value: productId, onChange: onChange },
  } = useController({ name: "custom_data.qrv5.random_pincodes.article_message_id" });
  const apiProvider = useWatch({ name: "apiProvider" });
  const featureSupported = apiProviderSupportsFeature(apiProvider, "dispatch_message_to_pos");

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
      <Card sx={{ p: 2 }}>
        <Stack>
          <h3>
            <TranslationWrapper tDefault={"Security"} tKey={"vestigingen.form.secuirity.headers.secuirity"} />
          </h3>

          <FormTextTC name={"wip"} tDefault={"Web IP ACL"} tKey={"vestigingen.form.algemeen.label.wip"} />
          <FormTextTC
            name={"faultMobileNr"}
            tDefault={"Mobiel nummer voor errors"}
            tKey={"vestigingen.form.autoreports.label.faultMobileNr"}
          />
          <FormTextTC
            name={"faultMailAddress"}
            tDefault={"Mail adres voor errors"}
            tKey={"vestigingen.form.autoreports.label.faultMailAddress"}
          />
          <FormSwitchTC
            name={"skipIdCheck"}
            tDefault={"Redirect ID check login"}
            tKey={"vestigingen.form.overige.label.skipIdCheck"}
          />
          {/* // verify-sms option  is temporarily disabled */}
          {/* <FormSwitchTC
              name={"extra_settings__verifysms"}
              tKey={"extra_settings.fields.label.verifysms"}
              tDefault={"Verify order SMS"}
            /> */}
          <FormSwitchTC
            name={"extra_settings__verifymail"}
            tDefault={"Verify order mail"}
            tKey={"extra_settings.fields.label.verifymail"}
          />

          <Box>
            <FormSwitchTC
              disabled={!featureSupported}
              name={"custom_data.qrv5.random_pincodes.enabled"}
              tDefault={"Use random pincodes for each table"}
              tKey={"custom_data.qrv5.random_pincodes.enabled"}
              warning={{
                hasWarning: !featureSupported,
                text: {
                  tKey:
                    "Supported POS's: " +
                    apiProviderSupportsFeatureList("dispatch_message_to_pos")
                      .map((a) => a.label)
                      .join(", "),
                },
              }}
            />
          </Box>
          <Collapse in={Boolean(useRandomPincode)} sx={{ width: 1 }}>
            <Typography>If you have a POS connection, make sure to setup a message article.</Typography>
            <FormCustomizableTextTC
              model={"vestiging"}
              modelId={vestigingId}
              tDefault={"Extra explanation shown in the dialog which asks for the pincode"}
              tKey={"In app explanation"}
              translatableText={"use_random_pincodes_enter_pincode_explanation"}
            />
            <TranslationWrapper
              tDefault={"Article used for communication of pincode to POS"}
              tKey={"Article used for communication of pincode to POS"}
            />
            <AsyncProductAutocomplete
              async_url={`core/producten/search?fields=id as value,naam as label,blocked,is_actief,snaam,prijs&sort_field=naam&vestiging_id=${
                menukaartVestigingId ?? vestigingId
              }&extraFilters=[${encodeURIComponent(
                JSON.stringify([{ field: "apiId2", operator: "=", value: null }])
              )}]`}
              multiple={false}
              name={"custom_data.qrv5.random_pincodes.article_message_id"}
              onChange={(option) => {
                onChange({ target: { value: option?.value ?? "" } }, option?.value ?? "");
              }}
              value={productId ? JSON.parse(productId) : null}
            />
          </Collapse>
        </Stack>
      </Card>

      <Card sx={{ p: 3 }}>
        <Stack>
          <h3>
            <TranslationWrapper tDefault={"Anonimiseren"} tKey={"vestigingen.form.algemeen.headers.anonymize"} />
          </h3>
          <FormTextTC name={"hours"} tDefault={"Hours"} tKey={"vestigingen.form.anonymize.label.hours"} />
          <FormTextTC name={"days"} tDefault={"Days"} tKey={"vestigingen.form.anonymize.label.days"} />
          <FormTextTC name={"months"} tDefault={"Months"} tKey={"vestigingen.form.anonymize.label.months"} />
        </Stack>
      </Card>
    </Box>
  );
}
